import { createUseStyles } from 'react-jss'
import { tabletDown } from '../../../../styles/const/breakpoints'
import { black } from '../../../../styles/const/colors'

const useStyles = createUseStyles({
  title: {
    fontSize: 20,
    color: black,
    margin: '16px 0 8px'
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    padding: 10,
    width: 32,
    height: 32,
    cursor: 'pointer'
  },
  successText: {
    marginTop: 0
  },
  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
    columnGap: 8,
    marginTop: 24
  },
  progressBtn: {
    marginTop: 35,
    width: 'initial'
  },
  [`@media screen and (${tabletDown})`]: {
    progressBtn: {
      width: '100%'
    }
  }
})

export default useStyles
